import { Activity } from 'react';

import { Switch } from 'antd';

import { HelpText } from './HelpText';

export const SwitchableSection = ({
  children,
  isActive,
  onChange,
  title,
  description,
  className
}: {
  children: React.ReactNode;
  isActive: boolean;
  onChange?: () => void;
  title: string;
  description: string;
  className?: string;
}) => {
  return (
    <div className={className}>
      <div className='flex flex-row'>
        <div className='flex flex-1 flex-col'>
          <span className='block font-medium'>{title}</span>
          <HelpText className='block'>{description}</HelpText>
        </div>
        <Activity mode={onChange ? 'visible' : 'hidden'}>
          <div>
            <Switch onChange={onChange} checked={isActive} id='cancelSubscriptionSwitch' />
          </div>
        </Activity>
      </div>
      <Activity mode={isActive ? 'visible' : 'hidden'}>
        <div className='mt-2 flex flex-col gap-2'>{children}</div>
      </Activity>
    </div>
  );
};
